import { Avatar, Box, Flex, Stack, Text } from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { EditProfile } from './components/EditProfile';
import { AuthContext } from '../../context/authContext';
import { getTenantProfileSettings } from './service';
import FullPageLoader from '../../components/FullPageLoader';
import { UserProfileContext } from '../../context/userProfileContext';
import Container from '../../components/Container';
import Header from '../../components/Header';
import Notifications from './components/Notifications';
import MoreSettings from './components/MoreSettings';

const Settings = () => {
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const { userProfile } = useContext(UserProfileContext);
  const [isLoading, setIsLoading] = useState(false);
  const [tenantProfile, setTenantProfile] = useState({});
  const [refresh, setRefresh] = useState({});

  useEffect(() => {
    getTenantProfileSettings(userId, setIsLoading, setTenantProfile);
  }, [userId, refresh]);

  console.log(tenantProfile, userInfo);

  return isLoading ? (
    <FullPageLoader />
  ) : (
    <>
      <Box shadow='sm'>
        <Container>
          <Header />
        </Container>
      </Box>
      <Container>
        <Box bg='#FFFFFF' my='10'>
          <Flex
            bg='primary'
            align='center'
            gap='1em'
            p='30px 20px'
            borderRadius='10px'
          >
            <Avatar
              src={userProfile?.profilePicture}
              size='xl'
              name={userProfile?.tenantName}
            />
            <Stack color='#fff'>
              {/* <Text fontSize='1.5rem'>{userProfile?.tenantName}</Text> */}
              <Text fontSize={['18px', '20px']} fontWeight='500'>
                {userProfile?.tenantName}
              </Text>
              <EditProfile setRefresh={setRefresh} />
            </Stack>
          </Flex>

          <Notifications />

          <MoreSettings />
        </Box>
      </Container>
    </>
  );
};

export default Settings;
